import axios from "axios";
import {
    authHeader,
    handleResult,
    handleException,
} from '../helpers';

export const distributionChannelService = {
    getAll,
};

function getAll() {

    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("distributionchannels", requestOptions).then(handleResult).then(p => {
        return p;
    }).catch(handleException);
}